import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { WEB_ROUTES } from "../../constants";
import { RootState } from "store";
// import { getToken } from "../../Data/services/localStorageService";

interface PublicRouteProps {
  children: React.ReactNode;
}

const PublicRoute: React.FC<PublicRouteProps> = ({ children }): JSX.Element => {
  const { isLoggedIn } = useSelector((state: RootState) => state.auth)
  // const token = true;

  return isLoggedIn ? (
    <Navigate to={WEB_ROUTES.HOME} replace={true} />
  ) : (
    <>{children}</>
  );
};

export default PublicRoute;
